import { isLinkedInDocumentUrl } from '@shared/linkedin-media-rules';

/**
 * A LinkedIn document (PDF, PPT, PPTX, DOC, DOCX) is stored in a post's `media_urls` like an image, but a browser
 * cannot draw it as one: an `<img>` pointed at it downloads the whole file (up to 100 MB) and fails. Every place that
 * draws a post's first media as a thumbnail takes its URL through here, and draws a document tile for a document.
 */
export const isDocumentMediaUrl = (url: string | null | undefined): boolean =>
  typeof url === 'string' && url.length > 0 && isLinkedInDocumentUrl(url);

/** The first URL a browser can draw as a picture (an image, or a video's poster frame), skipping documents. */
export function firstVisualMediaUrl(
  urls: ReadonlyArray<string | null | undefined> | null | undefined,
): string | undefined {
  if (!Array.isArray(urls)) return undefined;
  return urls.find(
    (url): url is string => typeof url === 'string' && url.length > 0 && !isDocumentMediaUrl(url),
  );
}

/** The first document URL, or undefined. */
export function firstDocumentMediaUrl(
  urls: ReadonlyArray<string | null | undefined> | null | undefined,
): string | undefined {
  if (!Array.isArray(urls)) return undefined;
  return urls.find((url): url is string => isDocumentMediaUrl(url));
}
